var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoWhatsapp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m0 15.99 1.125-4.106a7.91 7.91 0 0 1-1.058-3.96C.068 3.553 3.624 0 7.993 0c2.12.001 4.11.826 5.606 2.324a7.874 7.874 0 0 1 2.32 5.605c-.002 4.369-3.558 7.924-7.926 7.924h-.004a7.922 7.922 0 0 1-3.787-.965L0 15.99Z",
  fill: "#fff"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.995 1.338a6.596 6.596 0 0 0-6.59 6.586 6.569 6.569 0 0 0 1.006 3.504l.157.25-.665 2.43 2.493-.654.24.142a6.58 6.58 0 0 0 3.354.918h.002a6.596 6.596 0 0 0 6.09-9.108 6.544 6.544 0 0 0-1.43-2.136 6.544 6.544 0 0 0-4.657-1.932Z",
  fill: "url(#a)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.011 4.61c-.148-.33-.304-.336-.445-.342l-.38-.004a.727.727 0 0 0-.528.247c-.181.199-.693.678-.693 1.652 0 .974.71 1.916.808 2.048.1.132 1.37 2.196 3.383 2.99 1.673.66 2.014.528 2.377.495.363-.033 1.172-.479 1.337-.941.165-.463.165-.86.115-.942-.05-.083-.181-.132-.38-.231-.198-.1-1.171-.578-1.353-.644-.181-.067-.313-.1-.445.099a11.59 11.59 0 0 1-.627.776c-.116.132-.231.149-.43.05-.198-.1-.835-.308-1.592-.983-.589-.525-.986-1.173-1.102-1.371-.116-.198-.012-.306.087-.404.09-.09.198-.232.297-.347.1-.116.132-.199.198-.33.066-.132.033-.248-.016-.347-.05-.1-.435-1.079-.61-1.47Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 7.858,
  y1: 2.129,
  x2: 7.925,
  y2: 13.389,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57D163"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23B33A"
})))));
export { SvgIcoWhatsapp as ReactComponent };
export default __webpack_public_path__ + "assets/media/ico-whatsapp.ae83581be754b515ca50ade4d3112bf9.svg";